// stores/useModalStore.js
import { create } from 'zustand';

export const useModalStore = create((set) => ({
  modals: {
    forgot: false,
    verification: false,
    reset: false,
    success: false,
    onboarding: false,
    signupSuccess: false,
    firmOffer: false,
    loginPrompt: false,
  },
  modalContext: null, // ✅ keep track of why modal was opened

  // open a modal by name + optional context
  openModal: (name, context = null) =>
    set((state) => ({
      modals: { ...state.modals, [name]: true },
      modalContext: context,
    })),

  // close a modal by name
  closeModal: (name) =>
    set((state) => ({
      modals: { ...state.modals, [name]: false },
      modalContext: null, // reset context when closing
    })),

  // close all modals
  closeAll: () =>
    set(() => ({
      modals: {
        forgot: false,
        verification: false,
        reset: false,
        success: false,
        onboarding: false,
        signupSuccess: false,
        firmOffer: false,
        loginPrompt: false,
      },
      modalContext: null,
    })),
}));
